





























import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import CarbonFootprintPlotWrapperObject from '@/CarbonFootprintPlotWrapperObject.vue';
import FoodSafetyPlotWrapperObject from '@/FoodSafetyPlotWrapperObject.vue';
import Plotly from 'src/misc/external/plotly';


@Component({
  components: {
    CarbonFootprintPlotWrapperObject,
    FoodSafetyPlotWrapperObject,
  }
})
export default class FoodSafetyAndCarbonFootprintCard extends Vue {

  get boards() {
    return this.$store.state.currentProject.boards;
  }

  get card() {
    return this.$store.getters.getCard('GraphsCard');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FoodSafetyAndCarbonFootprintCard.vue